import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface EditPricingProfileDialogData {
    code: string;
    name: string;
    description: string;
}

export interface EditPricingProfileDialogResult {
    name: string;
    description: string;
}

@Component({
    selector: 'app-edit-pricing-profile-dialog',
    templateUrl: './edit-pricing-profile-dialog.component.html',
    styleUrls: ['./edit-pricing-profile-dialog.component.scss']
})
export class EditPricingProfileDialogComponent {
    form: FormGroup;

    constructor(
        public dialogRef: MatDialogRef<EditPricingProfileDialogComponent, EditPricingProfileDialogResult>,
        @Inject(MAT_DIALOG_DATA) public data: EditPricingProfileDialogData,
        private fb: FormBuilder
    ) {
        this.form = this.fb.group({
            code: [{ value: data.code, disabled: true }],
            name: [data.name, [Validators.required, Validators.maxLength(60)]],
            description: [data.description, [Validators.required, Validators.maxLength(180)]]
        });
    }

    onCancel(): void {
        this.dialogRef.close();
    }

    onSave(): void {
        if (this.form.invalid) {
            this.form.markAllAsTouched();
            return;
        }

        const raw = this.form.getRawValue();
        this.dialogRef.close({
            name: String(raw.name).trim(),
            description: String(raw.description).trim()
        });
    }
}
